import { number, object } from 'yup'

const rateOfReturnOptions = []
let i = 3
while (i <= 12) {
  rateOfReturnOptions.push({
    label: `${i} %`,
    value: i,
  })
  i++
}

const ageOptions = []
const yearsInSchoolOptions = []
let j = 1
while (j <= 18) {
  if (j <= 9) {
    yearsInSchoolOptions.push({
      label: `${j}`,
      value: j,
    })
  }

  ageOptions.push({
    label: `${j}`,
    value: j,
  })
  j++
}

export const formFields = {
  age: {
    label: 'How old is your child?',
    type: 'select',
    options: ageOptions,
  },
  yearsInSchool: {
    label: 'How long will your child attend post-secondary school?',
    type: 'select',
    options: yearsInSchoolOptions,
  },
  annualCost: {
    label: `What is the estimated annual cost of your child's post-secondary education?`,
    type: 'text',
    class: 'Currency',
  },
  startingInvestment: {
    label: `How much do you currently have saved in your child's RESP?`,
    type: 'text',
    class: 'Currency',
  },
  monthlyContribution: {
    label: `How much do you plan to contribute on a monthly basis?`,
    type: 'text',
    class: 'Currency',
  },
  rateOfReturn: {
    label: 'What is your expected annual rate of return?',
    type: 'select',
    options: rateOfReturnOptions,
  },
}

export const formSchema = object().shape({
  age: number().typeError('age must be a number').required('this is required'),
  yearsInSchool: number()
    .typeError('must be a number')
    .required('this is required'),
  annualCost: number()
    .typeError('must be a number')
    .required('this is required'),
  startingInvestment: number()
    .min(0, 'Must be 0 or above')
    .typeError('must be a number'),
  monthlyContribution: number()
    .typeError('must be a number')
    .min(0, 'Must be 0 or above'),
})

export const initialValues = {
  age: '1',
  yearsInSchool: '1',
  annualCost: '',
  startingInvestment: '',
  monthlyInvestment: '',
  rateOfReturn: '3',
}
